<template>
  <div class="final-page">
    <div class="final-page__content">
      <h2>Тест успешно завершен!</h2>
      <div class="final-page__text">
        <p>Мы проанализировали ваши ответы. Посмотрите свои сильные стороны и зоны роста, чтобы начать работу над развитием эмоционального интеллекта уже сегодня.</p>
        <p  v-if="!getRight('downloadReports') ||
                    test.status !== 'finished' ||
                    !test.allow_view_report ||
                    test.report_type === 'empty'">
          Вы найдете результаты тестирования в своем личном кабинете. Если вы
          были приглашены к тестированию компанией, за результатами обратитесь к
          отправителю ссылки на прохождение теста.
        </p>

        <div class="button-wrapper">
          <a-button
              v-if="getRight('downloadReports') &&
                    test.status === 'finished' &&
                    test.allow_view_report &&
                    test.report_type !== 'empty'"
              @click="getLink" class="primary-button" :loading="isPreloader">
            Скачать отчет
          </a-button>

          <a-button class="secondary-button" @click="router.push('/personal')">
            Вернуться в личный кабинет
          </a-button>
        </div>
        <p v-if="generationFailed" class="report_generation_failed_message">
          Отчет не сгенерирован, попробуйте позже.
        </p>
        <span v-if="showLink" class="redirect-link">
            <a :href="showLink" target="_blank">{{ showLink }}</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {useStore} from "vuex";
import {computed} from "@vue/runtime-core";
import useCheckRights from "@/mixins/useCheckRights";
import {ref} from "@vue/reactivity";
import {useRouter} from "vue-router";

export default {
  name: "final-page",
  setup() {
    const store = useStore(),
        {getRight} = useCheckRights();
    const isPreloader = ref(false),
        showLink = ref(null),
        test = computed(() => store.state.test.currentPassing),
        generationFailed = ref(false);
    const router = useRouter();

    const getLink = () => {
      isPreloader.value = true;
      generationFailed.value = false;
      store
          .dispatch("test/getReportLink", test.value.code)
          .then(({data}) => {
            if (data) {
              window.open(data, "Отчет");
              showLink.value = data;
            } else {
              generationFailed.value = true;
            }
          })
          .finally(() => (isPreloader.value = false));
    };


    return {
      'test': test,
      'getRight': getRight,
      'getLink': getLink,
      'showLink': showLink,
      generationFailed,
      router,
      isPreloader
    }
  }
};
</script>

<style scoped lang="scss">

.testing-container .final-page {
  h2 {
    font-size: 26px;
  }

  p {
    font-size: 14px;
  }
}

.final-page {
  text-align: left;
  padding: 10px 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  word-break: break-word;

  .report_generation_failed_message {
    margin-top: 20px;
  }

  &__content {
    margin: -5% auto 0;
    padding: 50px;

    h1 {
      font-size: 50px;
    }

    p {
      margin-bottom: 25px;
      font-size: 18px;
    }
  }

  &__link-section {
    font-size: 18px;

    p {
      margin-bottom: 6px;
    }

    a {
      color: var(--main-green);
    }

    margin-bottom: 25px;
  }

  @media (max-width: 1036px) {
    &__content {
      padding: 20px;
    }
  }
}

.button-wrapper {
  display: flex;
  gap: 10px;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;

    .button {
      width: 100%;
    }

  }
}
</style>